
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wellmaxx",
      function () {
        return require("private-next-pages/wellmaxx/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wellmaxx"])
      });
    }
  